import React from "react";
import {Input} from "reactstrap";
import {connect} from "react-redux";
import {
    isCurrentNewsletterTemporary,
    getAvailableNewsletters,
    getCurrentNewsletterName,
    getCurrentNewsletterGroupingId,
    getIsNewsletterHidden,
} from "../../../../redux/selectors/newsletters";
import {navigateToNewsletterEdition} from "../../../../redux/actions/navigation";
import {clearSearch} from "../../../../redux/actions/search";
import {isSearchActive} from "../../../../redux/selectors/search";

/**
 * create the newsletter dropdown or just output the newsletter name
 * @param {} props
 * @param {} props.availableNewsletters - list of newsletters. object keyed by groupingId.
 * @param {Array} props.availableNewsletters[groupingId].archiveDates
 *        - array containing *most recent date* for the newsletter, if any. contains 0-1 element.
 * @param {String} props.availableNewsletters[groupingId].name - name of the newsletter
 * @param {Boolean} props.isTemporary - true if a temporary CL-04
 * @param {String} props.newsletterName - name of the currently showing newsletter. note for temp
 *                                         CL-04 the newsletter could not be in the list of available
 *                                         newsletters????
 *@param {String} props.newsletterGroupingId - current newsletter groupingId
 * @return {}
 */
const AvailableNewsletters = (props) => {
    const {
        availableNewsletters,
        isTemporary,
        newsletterName,
        newsletterGroupingId,
        isNewsletterHidden,
    } = props;

    /**
     * handle the select change event
     * navigate the user to the most recent date of the selected newseltter
     * @param  {} event - synthetic event
     */
    const handleOnChange = event => {
        if (props.searchIsActive) {
            props.clearSearch();
        }

        const groupingId = event.target.value;

        const mostRecentDateArray = availableNewsletters[groupingId].archiveDates;

        props.changeNewsletter({
            date: mostRecentDateArray[0],
            groupingId: groupingId
        });
    };

    if (!isTemporary && !isNewsletterHidden && Object.keys(availableNewsletters).length > 1) {
        //output a dropdown
        return (
            <div className="input-group w-100 pb-3 px-3">
                <div className="input-group-prepend">
                    <label className="input-group-text" htmlFor="inputGroupSelect01">
                        <i className="far fa-ballot"></i>
                    </label>
                </div>

                <Input className="custom-select aside-input"
                        type="select"
                        name="select"
                        value={newsletterGroupingId || ""}
                        id="inputGroupSelect01"
                        onChange={handleOnChange}>
                            {Object.values(availableNewsletters).map(({groupingId, name}) => {
                                return <option
                                            key={groupingId}
                                            value={groupingId}>
                                                {name}
                                        </option>
                            })}
                </Input>
            </div>
        )
    } else {
        //temporary/hidden newsletter and newsletters with only one option just show name as text
        return (
            <div className="w-100 pb-3 px-3 text-truncate">
                <i className="far fa-ballot single-newsletter-icon"></i>
                {newsletterName}
            </div>
        )
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {}
 */
const mapStateToProps = (state) => {
    return {
        isTemporary: isCurrentNewsletterTemporary(state),
        availableNewsletters: getAvailableNewsletters(state),
        newsletterName: getCurrentNewsletterName(state),
        newsletterGroupingId: getCurrentNewsletterGroupingId(state),
        searchIsActive: isSearchActive(state),
        isNewsletterHidden: getIsNewsletterHidden(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {
        changeNewsletter: (params) => {
            dispatch(navigateToNewsletterEdition(params))
        },
        clearSearch: (isActive) => {
            dispatch(clearSearch())
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableNewsletters);
